import {css} from '@yandex-delivery/blocks/theme/css'

export const hidden = css`
  display: none;
`
